/**
 * Created by hernanherreros on 2019-05-27
 */

import * as React from 'react'
import styled from 'styled-components'
import LottieAnimation from '../../components/Utils/LottieAnimation'
import animation from '../../static/animations/not-found.json'
import { Trans } from '@lingui/macro'

export default () => (
  <Container>
    <Wrapper>
      <LottieAnimation animation={animation}/>
      <Text><Trans>La ruta que busca no existe</Trans></Text>
    </Wrapper>
  </Container>
)

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Wrapper = styled.div`
  max-width: 400px;
  width: 100%;
`
const Text = styled.h1`
  font-weight: 400;
  color: #666;
  text-align: center;  
 `